import { render } from "./LighboxWhoBoughtSkeleton.vue?vue&type=template&id=70afb016&scoped=true"
import script from "./LighboxWhoBoughtSkeleton.vue?vue&type=script&lang=js"
export * from "./LighboxWhoBoughtSkeleton.vue?vue&type=script&lang=js"

import "./LighboxWhoBoughtSkeleton.vue?vue&type=style&index=0&id=70afb016&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70afb016"]])

export default __exports__